import { html, ViewTemplate, repeat } from '@microsoft/fast-element';
import type { WatchlistContainer } from './watchlist';

export const WatchlistContainerTemplate: ViewTemplate<WatchlistContainer> = html`
  <div class="container">
    <div class="container-header">
      <h3 class="container-title">Watchlist</h3>
    </div>
    <div class="watchlist-list">
      ${repeat(
        (x, c) => x.projectList,
        html`
          <watchlist-project-card :project=${(x) => x}></watchlist-project-card>
        `
      )}
    </div>
  </div>
`;
